module.exports = __webpack_public_path__ + "img/sleeve length.a678140f.png";